import {Paper, Container, Typography, makeStyles} from "@material-ui/core";
import logo from '../assets/logo_white.svg'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center', flex: '1',
        '& > img': {
            maxWidth: 350,
        },
        '& .MuiPaper-root': {
            padding: theme.spacing(8, 4),
            width: '100%',
            textAlign: 'center',
            '& .MuiTypography-root': {
                margin: 'auto',
                maxWidth: 500,
                marginBottom: theme.spacing(4),
            }
        }
    }

}))

export default function ThankYouPage() {
    const classes = useStyles();
    return (
        <Container maxWidth="md" className={classes.root}>
            <img src={logo} style={{height:'200px'}} alt="MazingDay Logo" />
            <Paper>
                <Typography variant="h2" gutterBottom style={{fontWeight: 'bold'}}>
                    Thank you&nbsp;
                    <span style={{color: 'yellow'}}>!</span>
                    <span style={{color: 'lightgreen'}}>!</span>
                    <span style={{color: 'red'}}>!</span>
                </Typography>
                <Typography>
                    Thanks again for your time. You have successfully uploaded your files.
                    We will get back to you if we face any issues with the files that you have shared.
                </Typography>
                <Typography>
                    In the meantime, if you need to contact us, feel free to send us an email at the following address :<br />  <b>uae.activities@mazingday.com</b>
                </Typography>

            </Paper>
        </Container>
    )
}
